import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useWorkflows } from '@atlassian/jira-business-workflows';
import { useBoardStoreActions } from '../../services/board-store';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useFetchWorkflowsDetails = () => {
	const workflows = useWorkflows();

	const { setWorkflowsDetails } = useBoardStoreActions();

	useEffect(() => {
		if (!isEmpty(workflows)) {
			setWorkflowsDetails(workflows);
		}
	}, [workflows, setWorkflowsDetails]);
};
